"use client";

import React, { useState } from 'react';
import { useUser } from '@/zustand-hooks/user-hook';
import { InfoIcon, X } from 'lucide-react';
import { Card } from '@/components/ui/card';

const CustomerMessage: React.FC = () => {
    const { clientSettings } = useUser();
    const [isDismissed, setIsDismissed] = useState(false);
    
    const message = clientSettings?.message;

    if (!message || isDismissed) {
        return null;
    }

    return (
        <Card className="mb-4 border-brand-500/30 bg-brand-500/10 dark:bg-brand-500/10 dark:border-brand-500/30 p-4">
            <div className="flex items-start gap-3">
                <InfoIcon className="h-5 w-5 text-brand-600 dark:text-brand-400 mt-0.5 flex-shrink-0" />
                <div className="flex-1 text-brand-700 dark:text-brand-400">
                    <div className="whitespace-pre-wrap">{message}</div>
                </div>
                <button
                    onClick={() => setIsDismissed(true)}
                    className="text-brand-600 dark:text-brand-400 hover:text-brand-700 dark:hover:text-brand-400 flex-shrink-0"
                    aria-label="Закрыть сообщение"
                >
                    <X className="h-4 w-4" />
                </button>
            </div>
        </Card>
    );
};

export default CustomerMessage;

